import React, { useEffect, useRef, useState } from "react";
import { Html5Qrcode } from "html5-qrcode";
import { Camera, CameraOff, ScanLine } from "lucide-react";
import { Input } from "@/components/ui/input";

const REGION_ID = "carspa-qr-reader";

/** Camera QR reader (html5-qrcode) + manual member-number fallback. Calls onCode(rawText) once per scan. */
export function CardScanner({ onCode, busy }) {
  const [manual, setManual] = useState("");
  const [camera, setCamera] = useState(false);
  const [error, setError] = useState("");
  const scanner = useRef(null);
  const lastCode = useRef("");

  useEffect(() => {
    if (!camera) return undefined;
    const inst = new Html5Qrcode(REGION_ID, { verbose: false });
    scanner.current = inst;
    inst.start({ facingMode: "environment" }, { fps: 8, qrbox: { width: 220, height: 220 } },
      (text) => {
        if (text === lastCode.current) return;
        lastCode.current = text;
        onCode(text);
        setTimeout(() => { lastCode.current = ""; }, 4000);
      }, () => {})
      .catch((e) => { setError("Kameru se nepodařilo spustit — povolte přístup ke kameře nebo zadejte číslo ručně."); setCamera(false); console.error(e); });
    return () => { inst.stop().then(() => inst.clear()).catch(() => {}); scanner.current = null; };
  }, [camera, onCode]);

  const submitManual = (e) => { e.preventDefault(); if (manual.trim()) { onCode(manual.trim()); setManual(""); } };

  return (
    <div className="space-y-3" data-testid="card-scanner">
      <div className="flex flex-wrap items-center gap-2">
        <button type="button" onClick={() => { setError(""); setCamera((c) => !c); }} data-testid="scanner-toggle-camera"
          className={`h-10 px-4 inline-flex items-center gap-2 text-xs font-semibold ${camera ? "border border-brand-border hover:border-red-400 hover:text-red-400" : "bg-brand-accent text-black hover:bg-brand-accentHover"}`}>
          {camera ? <><CameraOff size={14} /> Vypnout kameru</> : <><Camera size={14} /> Naskenovat kartu kamerou</>}
        </button>
        <form onSubmit={submitManual} className="flex items-center gap-2 flex-1 min-w-[260px]">
          <Input data-testid="scanner-manual-input" value={manual} onChange={(e) => setManual(e.target.value)} placeholder="…nebo zadejte členské číslo (CSC-00001)"
            className="bg-brand-bg border-brand-border text-white h-10 text-sm font-mono" />
          <button type="submit" disabled={busy || !manual.trim()} data-testid="scanner-manual-submit"
            className="h-10 px-3 border border-brand-accent text-brand-accent text-xs font-semibold hover:bg-brand-accent hover:text-black disabled:opacity-50 inline-flex items-center gap-2">
            <ScanLine size={14} /> Načíst
          </button>
        </form>
      </div>
      {camera && <div id={REGION_ID} data-testid="scanner-camera-view" className="w-full max-w-[420px] border border-brand-accent/50 overflow-hidden [&_video]:w-full" />}
      {error && <div className="text-xs text-red-400" data-testid="scanner-error">{error}</div>}
    </div>
  );
}
